import { Line } from '@ant-design/charts';
import { SearchOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  DatePicker,
  Flex,
  Form,
  Radio,
  Row,
  Select,
  Space,
  Spin,
  Typography,
} from 'antd';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import reportApi from '../../../api/report';
import IntlMessage from '../../../components/IntlMessage';
import {
  formatCurrency,
  formatNumber,
  formatShortNumber,
} from '../../../helpers/helpers';
import useTime from '../../../hooks/useTime';
import {
  chartSalesType,
  chartType,
  dataDateType,
} from '../../../utils/constant';
import { debounce, isNumber } from 'lodash';

const { Text } = Typography;
const fs_16 = {
  fontSize: '16px',
};
const Overview = () => {
  const [form] = Form.useForm();
  const { formatAsISOString } = useTime();
  const [filter, setFilter] = useState({
    date_type: 'booking',
    mode: 'date',
  });
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [datas, setDatas] = useState([]);
  const [total, setTotal] = useState({
    today: {
      total_today: 0,
      total_cashier_today: 0,
      total_yobuma_today: 0,
      total_bagages_today: 0,
    },
    total: null,
    total_cashier: null,
    total_yobuma: null,
    total_bagages: null,
  });
  const [mode, setMode] = useState('date');
  const [type, setType] = useState(null);
  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      if (!filter.from_date || !filter.to_date) {
        await reportApi
          .getCashierOverview({
            ...filter,
            from_date: dayjs().startOf('day').toISOString(),
            to_date: dayjs().endOf('day').toISOString(),
          })
          .then((res) => {
            setTotal({
              today: {
                total_today: res?.today?.total_today,
                total_cashier_today: res?.today?.total_cashier_today,
                total_yobuma_today: res?.today?.total_yobuma_today,
                total_bagages_today: res?.today?.total_bagages_today,
              },
              total: res?.total,
              total_cashier: res?.total_cashier,
              total_yobuma: res?.total_yobuma,
              total_bagages: res?.total_bagages,
            });
            setLoading(false);
          })
          .catch((error) => {
            console.error(error);
            setLoading(false);
          });
      }
      await reportApi
        .getCashierOverview({
          from_date: dayjs().startOf('week').toISOString(),
          to_date: dayjs().endOf('week').toISOString(),
          ...filter,
        })
        .then((res) => {
          console.log('res', res.data);
          setItems(res?.data);
          setDatas(res?.data);
          if (filter.from_date || filter.to_date) {
            setTotal({
              today: {
                total_today: res?.today?.total_today,
                total_cashier_today: res?.today?.total_cashier_today,
                total_yobuma_today: res?.today?.total_yobuma_today,
                total_bagages_today: res?.today?.total_bagages_today,
              },
              total: res?.total,
              total_cashier: res?.total_cashier,
              total_yobuma: res?.total_yobuma,
              total_bagages: res?.total_bagages,
            });
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error(error);
          setLoading(false);
        });
    }
    fetchData();
  }, [filter]);

  const option = {
    data: items,
    xField: 'date',
    yField: 'subtotal',
    seriesField: 'title',
    animation: {
      appear: {
        animation: 'path-in',
        duration: 1000,
      },
    },
    encode: {
      x: 'date',
      y: 'subtotal',
      color: 'title',
    },

    scale: {
      color: {
        domain: ['total', 'caissier', 'yobuma', 'bagages'],
        range: ['#52c41a', '#3c74ce', '#722ed1', '#fa541c'],
      },
    },
    shapeField: 'smooth',
    point: {
      shapeField: 'square',
      sizeField: 1,
    },
    legend: {
      color: {
        layout: {
          justifyContent: 'center',
          alignItems: 'center',

          flexDirection: 'column',
        },
      },
    },
    axis: {
      y: {
        position: 'right',
        labelFormatter: (value) => {
          console.log('value', value);
          return formatShortNumber(Number(value));
        },
        gridLineWidth: 2,
        gridStroke: '#3c74ce',
        gridLineDash: [0, 0],
      },
      x: {
        labelFormatter: (value) => {
          return /^[-]?\d+$/.test(String(value).trim())
            ? `${String(Number(value)).padStart(2, '0')}:00`
            : dayjs(value, 'YYYY/MM/DD').format('DD MMM YY');
        },
        labelAutoRotate: false,
        labelAutoHide: true,
      },
    },
    style: {
      lineWidth: 2.5,
      // stroke: '#fa541c',
      // strokeOpacity: 1,
    },
    interaction: {
      tooltip: {
        render: (e, { title, items }) => {
          const list = items;
          const item = items.find((item) => item.name === 'date');
          const ORDER = ['total', 'caissier', 'yobuma', 'bagages'];

          const sortedList = list
            .filter((item) => item.name !== 'date' && item.name !== 'subtotal')
            .sort((a, b) => ORDER.indexOf(a.name) - ORDER.indexOf(b.name));

          return (
            <div key={title}>
              <div>
                {/^[-]?\d+$/.test(String(title).trim())
                  ? `${String(Number(title)).padStart(2, '0')}:00`
                  : dayjs(title).format('DD MMM YY')}
              </div>
              {sortedList.map((item) => {
                const { value, name, color } = item;
                console.log('item', item);
                return (
                  <div>
                    <div
                      style={{
                        margin: 0,
                        display: 'flex',
                        justifyContent: 'space-between',
                        minWidth: 200,
                      }}>
                      <div>
                        <span
                          style={{
                            display: 'inline-block',
                            width: 6,
                            height: 6,
                            borderRadius: '50%',
                            backgroundColor: color,
                            marginRight: 6,
                          }}></span>
                        <span>
                          {name === 'caissier'
                            ? 'Caissier'
                            : name === 'total'
                              ? 'Total'
                              : name === 'yobuma'
                                ? 'Yobuma'
                                : 'Bagages'}
                        </span>
                      </div>
                      <b>{formatCurrency(value)}</b>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        },
      },
    },
  };

  const onSearch = () => {
    form.validateFields().then((values) => {
      console.log('values', values);
      setFilter({
        ...filter,
        mode,
        from_date:
          mode === 'date'
            ? values.from_date?.toISOString()
            : values.from_date?.startOf(mode).toISOString(),
        to_date:
          mode === 'date'
            ? values.to_date?.toISOString()
            : values.from_date?.endOf(mode)?.toISOString(),
      });
    });
  };

  const onChangeMode = (value) => {
    setMode(value);
    // setFilter({
    //   mode: value,
    //   from_date: dayjs().startOf(value).toISOString(),
    //   to_date: dayjs().endOf(value).toISOString(),
    // });
    form.setFieldsValue({
      from_date: mode === 'date' ? dayjs().startOf('week') : dayjs(),
      to_date: mode === 'date' ? dayjs().endOf('week') : dayjs(),
    });
  };
  const onChangeType = async (value) => {
    try {
      if (type === value) {
        setType(null);
        setItems(datas);
      } else {
        setType(value);
        const data = datas.filter((item) => item.title === value);
        setItems(data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const onFilter = debounce(async (value, title, type) => {
    setFilter((filter) => {
      return {
        ...filter,
        value: title,
      };
    });
  }, 300);
  return (
    <Space style={{ width: '100%' }} direction="vertical">
      <Row justify={'start'}>
        <Col>
          <Row>
            <Form form={form} onFinish={onSearch}>
              <Row justify={'start'}>
                {/* <Col>
                  <Radio.Group
                    name="date_type"
                    onChange={(e) =>
                      onFilter(e.target.value, e.target.name, '')
                    }
                    defaultValue={dataDateType[0].value}>
                    <Flex vertical>
                      {dataDateType?.map((item, index) => {
                        return (
                          <Radio key={index} value={item?.value}>
                            {item?.label}
                          </Radio>
                        );
                      })}
                    </Flex>
                  </Radio.Group>
                </Col> */}
                <Col>
                  <Form.Item
                    name={'mode'}
                    initialValue={'date'}
                    rules={[
                      {
                        required: true,
                        message: <IntlMessage id="global.requiredfeild" />,
                      },
                    ]}>
                    <Select
                      placeholder="Select mode"
                      onSelect={onChangeMode}
                      options={[
                        {
                          value: 'date',
                          label: <IntlMessage id="global.date" />,
                        },
                        {
                          value: 'month',
                          label: <IntlMessage id="global.month" />,
                        },
                        {
                          value: 'day',
                          label: <IntlMessage id="global.day" />,
                        },
                      ]}></Select>
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="from_date"
                    // initialValue={dayjs().startOf('week')}
                    dependencies={['mode', 'to_date']}
                    rules={[
                      {
                        required: false,
                        message: <IntlMessage id="global.requiredfeild" />,
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (getFieldValue('mode')) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error('Please select mode!!'),
                          );
                        },
                      }),
                    ]}>
                    <DatePicker
                      placeholder={
                        mode === 'month'
                          ? 'Mois'
                          : mode === 'date'
                            ? 'Date'
                            : 'Jour'
                      }
                      format={mode === 'month' ? 'MM-YYYY' : 'DD-MM-YYYY'}
                      picker={mode}
                      locale={'fr'}
                    />
                  </Form.Item>
                </Col>
                {mode === 'date' && (
                  <Col>
                    <Form.Item
                      name="to_date"
                      // initialValue={dayjs().endOf('week')}
                      dependencies={['mode', 'from_date']}
                      rules={[
                        {
                          required: false,
                          message: <IntlMessage id="global.requiredfeild" />,
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (
                              (value && getFieldValue('from_date')) ||
                              !getFieldValue('from_date')
                            ) {
                              return Promise.resolve();
                            }

                            return Promise.reject(
                              new Error('Please select from date!!'),
                            );
                          },
                        }),
                      ]}>
                      <DatePicker
                        placeholder="Date"
                        format={'DD-MM-YYYY'}
                        picker={mode}
                      />
                    </Form.Item>
                  </Col>
                )}
                <Col>
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      Filtrer
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Row>
        </Col>
      </Row>

      <Row gutter={[8, 8]} justify={'space-around'} wrap>
        <Col
          xs={{ span: 12 }}
          sm={{ span: 12 }}
          md={{ span: 6 }}
          lg={{ span: 6 }}>
          <Card
            bordered
            style={
              type === chartSalesType.TOTAL
                ? {
                    backgroundColor: '#15bc8c0f',
                    boxShadow: '#15bc8c 0px 0px 5px',
                    border: '1px solid #15bc8c',
                    height: '100%',
                  }
                : {
                    height: '100%',
                  }
            }
            hoverable={true}
            onClick={() => onChangeType(chartSalesType.TOTAL)}>
            <Space
              direction="vertical"
              style={{ width: '100%', textAlign: 'center' }}>
              <Text>
                <IntlMessage id="global.total" />
              </Text>
              <Text strong style={fs_16}>
                <Text>{formatCurrency(total?.total)}</Text>
              </Text>
              {/* <Flex justify="space-between" wrap>
                <Text>(Tod) </Text>
                <Text strong style={fs_16}>
                  {formatNumber(total?.today?.total_today || 0)}
                </Text>
              </Flex> */}
              {/* <Flex justify="space-between" wrap>
                <Text>
                  ({dayjs(filter.from_date).format('MMM DD')} -{' '}
                  {dayjs(filter.to_date).format('MMM DD')}){' '}
                </Text>
                <Text style={fs_16}>
                  <Text>{formatCurrency(total?.total)}</Text>
                </Text>
              </Flex> */}
            </Space>
          </Card>
        </Col>
        <Col
          xs={{ span: 12 }}
          sm={{ span: 12 }}
          md={{ span: 6 }}
          lg={{ span: 6 }}>
          <Card
            bordered
            style={
              type === chartSalesType.YOBUMA
                ? {
                    backgroundColor: '#15bc8c0f',
                    boxShadow: '#15bc8c 0px 0px 5px',
                    border: '1px solid #15bc8c',
                    height: '100%',
                  }
                : {
                    height: '100%',
                  }
            }
            hoverable={true}
            onClick={() => onChangeType(chartSalesType.YOBUMA)}>
            <Spin spinning={loading}>
              <Space
                direction="vertical"
                style={{ width: '100%', textAlign: 'center' }}>
                <Text>
                  <IntlMessage id="global.yobuma" />
                </Text>
                <Text strong style={fs_16}>
                  <Text>{formatCurrency(total?.total_yobuma)}</Text>
                </Text>
                {/* <Flex justify="space-between" wrap>
                  <Text>(Tod) </Text>
                  <Text strong style={fs_16}>
                    {formatNumber(total?.today?.total_yobuma_today || 0)}
                  </Text>
                </Flex> */}
                {/* <Flex justify="space-between" wrap>
                  <Text>
                    ({dayjs(filter.from_date).format('MMM DD')} -{' '}
                    {dayjs(filter.to_date).format('MMM DD')}){' '}
                  </Text>
                  <Text style={fs_16}>
                    <Text>{formatCurrency(total?.total_yobuma)}</Text>
                  </Text>
                </Flex> */}
              </Space>
            </Spin>
          </Card>
        </Col>
        <Col
          xs={{ span: 12 }}
          sm={{ span: 12 }}
          md={{ span: 6 }}
          lg={{ span: 6 }}>
          <Card
            bordered
            style={
              type === chartSalesType.CASHIER
                ? {
                    backgroundColor: '#15bc8c0f',
                    boxShadow: '#15bc8c 0px 0px 5px',
                    border: '1px solid #15bc8c',
                    height: '100%',
                  }
                : {
                    height: '100%',
                  }
            }
            hoverable={true}
            onClick={() => onChangeType(chartSalesType.CASHIER)}>
            <Spin spinning={loading}>
              <Space
                direction="vertical"
                style={{ width: '100%', textAlign: 'center' }}>
                <Text>
                  <IntlMessage id="global.cashier_name" />
                </Text>
                <Text strong style={fs_16}>
                  <Text>{formatCurrency(total?.total_cashier)}</Text>
                </Text>
                {/* <Flex justify="space-between" wrap>
                  <Text>(Tod) </Text>
                  <Text strong style={fs_16}>
                    {formatNumber(total?.today?.total_cashier_today || 0)}
                  </Text>
                </Flex> */}
                {/* <Flex justify="space-between" wrap>
                  <Text>
                    ({dayjs(filter.from_date).format('MMM DD')} -{' '}
                    {dayjs(filter.to_date).format('MMM DD')}){' '}
                  </Text>
                  <Text style={fs_16}>
                    <Text>{formatCurrency(total?.total_cashier)}</Text>
                  </Text>
                </Flex> */}
              </Space>
            </Spin>
          </Card>
        </Col>
        <Col
          xs={{ span: 12 }}
          sm={{ span: 12 }}
          md={{ span: 6 }}
          lg={{ span: 6 }}>
          <Card
            bordered
            style={
              type === chartSalesType.BAGAGES
                ? {
                    backgroundColor: '#15bc8c0f',
                    boxShadow: '#15bc8c 0px 0px 5px',
                    border: '1px solid #15bc8c',
                    height: '100%',
                  }
                : {
                    height: '100%',
                  }
            }
            hoverable={true}
            onClick={() => onChangeType(chartSalesType.BAGAGES)}>
            <Spin spinning={loading}>
              <Space
                direction="vertical"
                style={{ width: '100%', textAlign: 'center' }}>
                <Text>
                  <IntlMessage id="global.bagages_name" />
                </Text>
                <Text strong style={fs_16}>
                  <Text>{formatCurrency(total?.total_bagages)}</Text>
                </Text>
              </Space>
            </Spin>
          </Card>
        </Col>
      </Row>
      <br />
      <Row gutter={16} justify={'space-around'} wrap>
        <Col span={24} style={{ textAlign: 'center' }}>
          <br />
          {loading ? (
            <Spin spinning={loading}></Spin>
          ) : (
            <div style={{ height: '400px' }}>
              <Line {...option} />
            </div>
          )}
        </Col>
      </Row>
    </Space>
  );
};

export default Overview;
